import { render } from "./TechIcon.vue?vue&type=template&id=0bae4a74&scoped=true"
import script from "./TechIcon.vue?vue&type=script&lang=js"
export * from "./TechIcon.vue?vue&type=script&lang=js"

import "./TechIcon.vue?vue&type=style&index=0&id=0bae4a74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bae4a74"]])

export default __exports__